/* eslint-disable import/no-anonymous-default-export */
import ThirdParty from "supertokens-auth-react/recipe/thirdparty";
import Session from "supertokens-auth-react/recipe/session";
import Multitenancy from "supertokens-auth-react/recipe/multitenancy";
import React from 'react';

//supertokens-auth-react API
//https://supertokens.com/docs/auth-react/0.27.X/modules/recipe_thirdparty.html
//https://github.com/supertokens/supertokens-auth-react

//Implementation Guide
//https://supertokens.com/docs/emailpassword/pre-built-ui/setup/frontend
// NEW VERSION !!!! https://supertokens.com/docs/references/frontend-sdks/prebuilt-ui/changing-colours
export const getSuperTokenConfig = (tennantID, formFields, buttonRef) => {
    return {
        languageTranslations: {
            translations: {
                en: {
                    BRANDING_POWERED_BY_START: "Power by Built Intelligence(v" + process.env.REACT_APP_VERSION + ") and ",
                    THIRD_PARTY_SIGN_IN_AND_UP_HEADER_TITLE: "FastDraft SSO Login"
                },
            },
            defaultLanguage: "en",
        },
        appInfo: {
            appName: "Built Intelligence SSO",
            apiDomain: "https://passport.builtintelligence.com",
            websiteDomain: window.location.origin,//"https://lantisuat.builtintelligence.com",
            apiBasePath: "/auth",
            websiteBasePath: process.env.REACT_APP_SSO_METHOD === 'DISCOVER' ? "/auth/discover/supertoken" : "/auth",
        },
        style:`
        [data-supertokens~=button] {
            background-color: #3f96c4 !important;
            color: #fff !important;
            borderColor: #3f96c4 !important;
        }
        [data-supertokens~="providerButtonText"] {
            font-weight: 700;
            font-size: 13.3px;
        }
        [data-supertokens~="headerTitle"] {
            font-weight: 800;
        }
    `,
        usesDynamicLoginMethods: true,
        recipeList: [
            ThirdParty.init(),
            Multitenancy.init({
                override: {
                    functions: (oi) => {
                        return {
                            ...oi,
                            getTenantId: async (input) => {
                                return tennantID ? tennantID : window.location.hostname.split(".")[0] // superTokensTenantId - subdomain (same mapping as the backend)
                            }
                        }
                    }
                }
            }),
            Session.init(),
        ],

    };
}

